import script from "./EpkQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./EpkQuestion.vue?vue&type=script&setup=true&lang=js"

import "./EpkQuestion.vue?vue&type=style&index=0&id=c1d2e7e2&lang=scss"

const __exports__ = script;

export default __exports__